export interface MentionUserLike {
  fullName?: string | null;
  email: string;
}

/** Primeiro nome para menção; fallback para e-mail */
export function getMentionDisplayName(user: MentionUserLike): string {
  const trimmed = user.fullName?.trim();
  if (trimmed) {
    return trimmed.split(/\s+/)[0];
  }
  return user.email;
}
